export const SET_GENERICS = 'SET_GENERICS';
export const SET_IS_LOADING_GENERICS = 'SET_IS_LOADING_GENERICS';
export const UPDATE_GENERIC = 'UPDATE_GENERIC';
